import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    Typography,
    CircularProgress,
} from "@mui/material";
import useAxiosPrivate from "utils/hooks/useAxiosPrivate";
import ModalCloseButton from "../../../components/UI/ModalCloseButton";
import {
    modalBackdropProps,
    MODAL_PAPER_SX,
} from "../../../utils/styles/modal.overlay";
import { sleepTheme } from "./sleepReportTheme";

function ViewReport({ selectedReport, open, onClose }) {
    const axios = useAxiosPrivate();
    const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
    const [pdfLoading, setPdfLoading] = useState(false);
    const [pdfError, setPdfError] = useState(false);

    useEffect(() => {
        let objectUrl = null;

        const fetchPdf = async () => {
            const pdfUrl = selectedReport?.report_pdf ?? selectedReport?.pdf_url;
            if (!open || !pdfUrl) {
                setPdfBlobUrl(null);
                return;
            }

            setPdfLoading(true);
            setPdfError(false);

            try {
                const { data } = await axios.get(pdfUrl, {
                    responseType: "blob",
                });
                objectUrl = URL.createObjectURL(
                    new Blob([data], { type: "application/pdf" }),
                );
                setPdfBlobUrl(objectUrl);
            } catch {
                setPdfError(true);
            } finally {
                setPdfLoading(false);
            }
        };

        fetchPdf();

        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
            setPdfBlobUrl(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open, selectedReport?.report_pdf]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="lg"
            fullWidth
            BackdropProps={modalBackdropProps}
            PaperProps={{
                sx: {
                    ...MODAL_PAPER_SX,
                    borderRadius: "16px",
                    width: "1000px",
                    maxWidth: "calc(100vw - 48px)",
                    maxHeight: "calc(100vh - 64px)",
                    height: "calc(100vh - 64px)",
                    padding: "24px",
                    display: "flex",
                    flexDirection: "column",
                },
            }}
        >
            <ModalCloseButton onClick={onClose} />

            <DialogContent
                style={{
                    marginTop: "15px",
                    padding: "0 0 24px 0",
                    overflowY: "auto",
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <div
                    style={{
                        flex: 1,
                        minHeight: 0,
                        marginTop: "15px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {pdfLoading && (
                        <CircularProgress
                            style={{ color: sleepTheme.accent }}
                        />
                    )}
                    {pdfError && (
                        <Typography
                            style={{
                                fontFamily: "Poppins",
                                fontSize: "14px",
                                color: "#d32f2f",
                            }}
                        >
                            Failed to load PDF.
                        </Typography>
                    )}
                    {pdfBlobUrl && !pdfLoading && (
                        <iframe
                            src={pdfBlobUrl}
                            title="Report PDF"
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                                display: "block",
                            }}
                        />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default ViewReport;
